<div id="anti-ragging-cell" class="inner-page py-4">
  <div class="container px-lg-5">

    <h2 class="title text-center">Ragging Free Campus</h2>

    <div class="text-center mb-5">
      <h2 class="fw-bold text-orange mb-3" style="color: #f48020; font-family: 'Outfit', sans-serif;">“Unity in Respect:
        A Ragging-Free Campus”</h2>
      <hr class="divider mx-auto" style="width: 80px; height: 3px; background: var(--primary); border: none; opacity: 1;">
    </div>

    <!-- Intro Column Layout (Matches Screenshot) -->
    <div class="row g-5 align-items-center mb-5">
      <!-- Main Photo -->
      <div class="col-12 col-lg-6">
        <div class="rounded-4 overflow-hidden shadow-md border border-light" style="border-width: 1px;">
          <img src="/assets/img/facility/anti-ragging-campus/ragging-free-campus11-scaled.jpg"
            alt="Ragging Free Campus Session" class="img-fluid w-100 d-block"
            style="object-fit: cover; max-height: 400px;"
            onerror="this.src='/assets/img/facility/anti-ragging-campus/ragging-free-campus-577x400.jpg'">
        </div>
      </div>

      <!-- Description Text -->
      <div class="col-12 col-lg-6">
        <div class="pe-lg-3"
          style="font-family: 'Inter', sans-serif; font-size: 15px; color: #495057; line-height: 1.8;">
          <p class="mb-4 text-justify">
            Welcome to Shah Satnam Ji Girls' College, Sirsa, where tradition and modernity converge to create a
            nurturing and respectful environment. Our Campus is proud to be completely ragging-free, ensuring a safe and
            supportive atmosphere for all students.
          </p>
          <p class="mb-4 text-justify">
            At the heart of our community lies a unique tradition: Senior students welcome juniors with a symbolic
            <strong class="text-dark fw-bold">Tilak ceremony</strong>, <strong class="text-dark fw-bold">signifying
              respect and goodwill</strong>. This gesture embodies our commitment to fostering a culture of guidance,
            mentorship, and camaraderie.
          </p>
          <p class="mb-0 text-justify">
            Here, seniors take on the role of mentors, guiding new students with care and wisdom, and helping them
            navigate the start of their academic journey. Join us to be the part of this Unique feature and legacy that
            values dignity, mutual respect, and academic excellence.
          </p>
        </div>
      </div>
    </div>

    <!-- Photo Gallery Grid -->
    <div class="mt-5 pt-4">
      <div class="text-center mb-4">
        <h3 class="fw-bold text-dark text-uppercase mb-2" style="font-family: 'Outfit', sans-serif;">Campus Activities
          Gallery</h3>
        <hr class="divider mx-auto mb-4"
          style="width: 60px; height: 3px; background: var(--primary); border: none; opacity: 1;">
      </div>

      <div class="row g-3 justify-content-center">
        <div class="col-6 col-sm-4 col-md-3" *ngFor="let img of antiRaggingImages">
          <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white position-relative gallery-item"
            style="border: 1px solid #eee; transition: transform 0.3s ease;">
            <img [src]="img" alt="Anti-Ragging Event" class="img-fluid w-100"
              style="object-fit: cover; height: 180px; transition: transform 0.3s ease;">
          </div>
        </div>
      </div>
    </div>

  </div>
</div>